import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-modal',
  templateUrl: './custom-modal.component.html',
})
export class CustomModalComponent {

  @Input() title!: string;
  @Input() hideCancel: boolean = false;
  @Input() hideSave: boolean = false;
  @Input() cancelLabel = 'Cancelar';
  @Input() cancelDisabled: boolean = false;
  @Input() saveLabel = 'Salvar Alterações';
  @Input() saveDisabled: boolean = false;
  @Input() hideFooter: boolean = false;
  @Input() hideClose: boolean = false;

  @Input() roundedBody: boolean = false;

  @Input() showReturn: boolean = false;

  @Output() onCancelClick = new EventEmitter<number>();
  @Output() onSaveClick = new EventEmitter<number>();
  @Output() onCloseClick = new EventEmitter<number>();
  @Output() onReturnClick = new EventEmitter<number>();

  public close() {

  }

  public dismiss() {
  }
}
